
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Rund ein Drittel aller Erwerbstätigen in der Schweiz leidet unter Schlafproblemen, das sind gegen 2 Millionen Menschen. Etwa 280’000 von ihnen können ohne Pillen nicht mehr schlafen. Und wer einmal eine Nacht wach gelegen hat, weiss, wie quälend es ist, schlafen zu wollen – aber nicht zu können.`}</p>
    <p>{`Was also tun, wenn der Schlaf nicht kommen will?`}</p>
    <I mdxType="I"><b>Runterkommen.</b> Machen Sie eine halbe Stunde vor dem Schlafengehen eine Sorgenliste. Dazu mögliche Lösungen notieren. Die Liste versorgen, aber nicht im Schlafzimmer. Ihre Sorgen sind jetzt nicht mehr im Kopf, und Sie haben mögliche Lösungen, die Sie morgen angehen können.
    </I><I mdxType="I"><b>Rhythmus.</b> Jeden Tag zur gleichen Zeit aufstehen. Das ist wichtiger, als zur selben Zeit ins Bett zu gehen. Denn der Tagesbeginn hat gewissermassen eine Ankerfunktion für unseren Biorhythmus.
    </I><I mdxType="I"><b>Warten.</b> Nicht ins Bett gehen, bevor man müde und schläfrig ist.
    </I><I mdxType="I"><b>Aufstehen.</b> Nicht im Bett liegen, wenn man nicht einschlafen kann. Klappt es nicht innert 15 bis 20 Minuten, aufstehen und einer beruhigenden Tätigkeit nachgehen.
    </I><I mdxType="I"><b>Disziplin.</b> Keine Nickerchen während des Tages.
    </I><I mdxType="I"><b>Gelassenheit.</b> Nicht um den Schlaf kämpfen. Wer kämpft, hat ihn schon verloren. Lieber denken: «Ich bleib jetzt mal ruhig liegen. Falls ich nicht schlafen kann, dann stehe ich halt wieder auf.»
    </I><I mdxType="I"><b>Essen und Trinken.</b> Am Abend Schlaf fördernde Lebensmittel wie Truthahn, Mandeln, Bananen und Honig essen. Warme Milch trinken.
    </I><I mdxType="I"><b>Ruhe.</b> Keine elektronischen Geräte im Schlafzimmer.
    </I><I mdxType="I"><b>Bewegung.</b> Keinen Sport vor dem Schlafengehen treiben. Er regt zu sehr an. Besser am Nachmittag trainieren und vor dem Schlafengehen noch einen kurzen Spaziergang machen.
    </I><I mdxType="I"><b>Alternativen.</b> Ersatz für Schlafmittel und Alkohol suchen. Sanfte Massagen, entspannende Musik, Akupunktur oder Lavendelöle sind Schlaf fördernd.
    </I><I mdxType="I"><b>Wohlgefühl.</b> In einem frisch bezogenen Bett schläft es sich besser.
    </I><I mdxType="I"><b>Klima.</b> Lüften Sie vor dem Schlafen zehn Minuten, um genügend frische Luft ins Schlafzimmer zu lassen. Besonders während der Heizperiode sollte man darauf achten, dass die Luftfeuchtigkeit hoch genug ist.
    </I><I mdxType="I"><b>Einsicht.</b> Es ist normal, im Alter weniger zu schlafen. Ältere Menschen haben weniger Tiefschlafanteile als jüngere.
      <video width="100%" controls poster="images/366207h.jpg">
  <source src="images/366207h.mp4" type="video/mp4" />
  <source src="images/Schlafforscherin-Fertig_1.webm" type="video/webm" />
      </video>
      <Tracking label='content50' mdxType="Tracking" />
    </I><I mdxType="I"><b>Mass halten.</b> Kaffee und Tee halten wach. Alkohol hilft zwar beim Einschlafen, stört aber den Schlafrhythmus nachhaltig.
    </I><I mdxType="I"><b>Rituale.</b> Stellen Sie sich Ihr eigenes kleines Programm zusammen, zum Beispiel ein paar Seiten lesen, Haare bürsten oder sich eincremen. Damit stellt sich Ihr Körper bereits auf «Einschlafen» ein.
    </I><I mdxType="I"><b>Leicht essen.</b> Schwere Mahlzeiten am Abend aktivieren die Verdauung und stören den Schlaf.
    </I><I mdxType="I"><b>Entspannen.</b> Autogenes Training, Progressive Muskelrelaxation, Meditation und Yoga helfen, den Geist zu beruhigen.
    </I><I mdxType="I"><b>Machen Sie einen Spaziergang vor dem Schlafengehen.</b> Die frische Luft und die Bewegung sind ideal zum Sortieren der Gedanken und zur Vorbereitung der körperlichen Umstellung auf den Schlafmodus.
    </I>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;